import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { CompleteYourLookSelectedTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackCompleteYourLookSelectedFunctionArgs {
  readonly buttonId: string;
}

interface TrackCompleteYourLookSelectedFunction {
  (args: TrackCompleteYourLookSelectedFunctionArgs): void;
}

interface UseTrackCompleteYourLookSelectedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCompleteYourLookSelectedFunction {
  (agrs: UseTrackCompleteYourLookSelectedFunctionArgs): TrackCompleteYourLookSelectedFunction;
}

const useTrackCompleteYourLookSelected: UseTrackCompleteYourLookSelectedFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const emitUserEvent = useEmitUserEvent<CompleteYourLookSelectedTrackingEvent>();

  const trackCompleteYourLookSelected: TrackCompleteYourLookSelectedFunction = useCallback(
    ({ buttonId }) => {
      emitUserEvent({
        event: TrackingEventName.COMPLETE_YOUR_LOOK_SELECTED,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        button: buttonId,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackCompleteYourLookSelected;
};

export { useTrackCompleteYourLookSelected };
